import * as React from 'react'
import {Link} from "gatsby";
import {Config} from "./vars";

const Header = ({props, className}) => {

    const logoUrl = Config.isTerminal ? '/' : 'https://www.bayern.landtag.de/';

    return (
        <header id="header" className={className}>
            <div className="container">
                <div className="row">
                    <div className="col-6 logo-row">
                        <div className="logo-blt">
                            <Link to={logoUrl} state={null}>
                                <img className="terminal" src={Config.prefix + "/images/BLT_Logo_blue.svg"}
                                     alt="Logo Bayerischer Landtag"/>
                            </Link>
                        </div>
                    </div>
                    <div className="col-6">
                        <h1>Der Landtag im Flug</h1>
                    </div>
                </div>
            </div>
        </header>
    )
}

export default Header
